import { withMutationEmitSuppressed } from "@/lib/mirrored-store";
import { useConversationStore } from "@/stores/conversation-store";

export function showOptimisticVoiceMessage(args: {
  requestId: string;
  text: string;
  conversationId?: string;
  sessionId?: string | null;
  conversationFrameId?: string | null;
}): void {
  // This row is local feedback. Broadcasting a full message-list patch from a
  // mirror can race the owner's authoritative message.created reconciliation.
  withMutationEmitSuppressed(() => {
    useConversationStore.getState().pushMessage({
      id: `optimistic-user-${args.requestId}`,
      role: "user",
      content: args.text,
      conversationId: args.conversationId,
      sessionId: args.sessionId ?? undefined,
      conversationFrameId: args.conversationFrameId ?? undefined,
      clientRequestId: args.requestId,
      createdAt: new Date().toISOString(),
      isOptimistic: true,
    });
  });
}

export function clearOptimisticVoiceMessage(requestId: string): void {
  withMutationEmitSuppressed(() => {
    useConversationStore.getState().clearOptimisticUserMessage(requestId);
  });
}

export function rekeyOptimisticVoiceMessage(
  requestId: string,
  nextRequestId: string,
): void {
  withMutationEmitSuppressed(() => {
    useConversationStore
      .getState()
      .rekeyOptimisticUserMessage(requestId, nextRequestId);
  });
}
